import { useCallback, useMemo } from 'react';

import { usePrzelewyOaltPaymentOnDemand } from '@api';
import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { IPrzelewyWebPaymentResponse } from '@model';
import { useRedirectUrl } from '@services/routingService';
import { EPage } from '@types';
import { goToUrl } from '@utils/navigation';

export const usePrzelewyOaltApi = () => {
  const { request: initiate } = usePrzelewyOaltPaymentOnDemand();
  const urlReturn = useRedirectUrl(EPage.PRZELEWY_PAYMENT_REDIRECT_PAGE);

  const {
    settings: { przelewyPaymentAddress },
  } = useApplicationBuildContext();

  const goToPrzelewy = useCallback(
    (token: string): void => {
      const redirectUrl = `${przelewyPaymentAddress}/${token}`;
      goToUrl(redirectUrl);
    },
    [przelewyPaymentAddress],
  );

  const onInit = useCallback(async (): Promise<IPrzelewyWebPaymentResponse | null> => {
    const response = await initiate({ urlReturn: urlReturn });

    if (!response?.token) {
      return null;
    }

    return response;
  }, [initiate, urlReturn]);

  return useMemo(
    () => ({
      onInit,
      goToPrzelewy,
    }),
    [goToPrzelewy, onInit],
  );
};
